/**
 * @file axios.js
 * @description 封装请求拦截与响应拦截
 */

import axios from 'axios';
import Qs from 'qs';
import {Tip, errCodeTip} from '@/utils/errorCode';

// 超时设定
axios.defaults.timeout = 10000;
axios.defaults.withCredentials = true;

/**
 * 请求封装
 */
axios.interceptors.request.use(config => {
    /* eslint-disable */
    _hmt.push(['_trackEvent', '发送请求', config.url]);
    /* eslint-enable */

    return config;
}, err => Promise.reject(err));

/**
 * 响应封装
 */
axios.interceptors.response.use(res => {
    if (res.status === 200 && res.data.errno === 0) {
        return Promise.resolve(res);
    }
    return Promise.reject(res);
}, err => Promise.reject(err));

/**
 * 请求函数get
 *
 * @param {string} url 请求路径
 * @param {Object} params 请求参数
 * @return {Promise}
 */
export const get = (url, params = {}) => {
    let prev = new Date().getTime();

    return axios.get(url + '?' + Qs.stringify(params, {arrayFormat: 'indices'}))
        .then(res => {
            let after = new Date().getTime();
            /* eslint-disable */
            _hmt.push(['_trackEvent', '请求成功', res.config.url, 'time', after - prev]);
            /* eslint-enable */

            return Promise.resolve(res.data.data);
        })
        .catch(err => {
            if (err.status && err.status === 200) {
                /* eslint-disable */
                _hmt.push(['_trackEvent', '错误码', err.config.url, err.data.errno + ':' + err.data.errmsg]);
                /* eslint-enable */

                return Promise.reject(errCodeTip(err.data.errno));
            }
            if (err.request) {
                /* eslint-disable */
                _hmt.push(['_trackEvent', '请求失败', err.config.url, err.message]);
                /* eslint-enable */
            }
            if (err.response) {
                /* eslint-disable */
                _hmt.push(['_trackEvent', '响应失败', err.config.url, err.message]);
                /* eslint-enable */
            }
            return Promise.reject(Tip.netError);
        });
};


/**
 * 请求函数post
 *
 * @param {string} url 请求路径
 * @param {Object} data 请求参数
 * @param {Object} header 请求头
 * @return {Promise}
 */
export const post = (url, data = {}, header = {}) => {
    if (Object.keys(header).length === 0) {
        data = Qs.stringify(data);
    }

    let prev = new Date().getTime();

    return axios.post(url, data, header)
        .then(res => {
            let after = new Date().getTime();
            /* eslint-disable */
            _hmt.push(['_trackEvent', '请求成功', res.config.url, 'time', after - prev]);
            /* eslint-enable */

            return Promise.resolve(res.data.data);
        })
        .catch(err => {
            if (err.status && err.status === 200) {
                /* eslint-disable */
                _hmt.push(['_trackEvent', '错误码', err.config.url, err.data.errno + ':' + err.data.errmsg]);
                /* eslint-enable */

                return Promise.reject(errCodeTip(err.data.errno));
            }
            if (err.request) {
                /* eslint-disable */
                _hmt.push(['_trackEvent', '请求失败', err.config.url, err.message]);
                /* eslint-enable */
            }
            if (err.response) {
                /* eslint-disable */
                _hmt.push(['_trackEvent', '响应失败', err.config.url, err.message]);
                /* eslint-enable */
            }
            return Promise.reject(Tip.netError);
        });
};

